import React from "react"
import { useLanguage } from "../../../context/LanguageContext"

const FeaturedCard = () => {
  const { content } = useLanguage()
  const { items } = content.home.featured

  return (
    <>
      <div className='content grid5 mtop'>
        {items.map((item) => (
          <div className='box' key={item.name}>
            <img src={item.cover} alt={item.name} />
            <h4>{item.name}</h4>
            <label>{item.total}</label>
          </div>
        ))}
      </div>
    </>
  )
}

export default FeaturedCard
